import { createPortal } from "preact/compat";
import { useEffect, useRef, useState } from "preact/hooks";

import styles from "./NotificationUI.module.css";
import { useNotificationStore } from "./useNotificationStore";

export const NotificationUI = () => {
  const [state, setState] = useState({ slidingIn: false });
  const showingNotification = useRef(false);
  const { notifications, rewardNotification, removeFirst, clearRewardNotification } = useNotificationStore();
  const standardNotif = notifications[0];

  useEffect(() => {
    let animTimeout: ReturnType<typeof setTimeout>;

    if (standardNotif && !showingNotification.current) {
      const durationMs = standardNotif.duration * 1000;

      //Slide it onto screen
      setState((state) => ({ ...state, slidingIn: true }));
      showingNotification.current = true;
      animTimeout = setTimeout(() => {
        //Slide it off screen
        setState((state) => ({ ...state, slidingIn: false }));
        animTimeout = setTimeout(() => {
          //Remove this notification and mark as ready for next
          removeFirst();
          showingNotification.current = false;
        }, 1000);
      }, durationMs);
    }
    return () => {
      clearTimeout(animTimeout);
      showingNotification.current = false;
    };
  }, [removeFirst, standardNotif]);

  useEffect(() => {
    let rewardTimeoutId: ReturnType<typeof setTimeout>;
    if (rewardNotification == undefined) return;

    // css doesn't have a way to simply reset an animation, so we have rely on tricks to do it
    const element = document.getElementById("reward-anim");
    if (element) {
      element.style.animation = "none";
      // TODO(peavey): QUESTION @alexandeli Is this a getter function?
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      element.offsetHeight; // explicity trigger DOM reflow to force the browser to re-calculate style & layout
      element.style.animation = `${styles.rewardAnim} ${rewardNotification.duration}s ease 0s 1 normal forwards`;

      rewardTimeoutId = setTimeout(() => {
        clearRewardNotification();
      }, rewardNotification.duration * 1000);
    }

    return () => {
      clearTimeout(rewardTimeoutId);
    };
  }, [rewardNotification, clearRewardNotification]);

  return createPortal(
    <div>
      <div className={styles.notificationOuterContainer}>
        <div className={`${styles.notificationInnerContainer} ${state.slidingIn ? styles.slideIn : ""}`}>
          <div className={`${styles.notificationTextBox} supportsRtl`}>
            {standardNotif && standardNotif.imageUrl && (
              <div className={styles.notificationImageBorder}>
                <img className={styles.notificationImage} src={standardNotif.imageUrl} />
              </div>
            )}
            {standardNotif && <div className={styles.notificationText}>{standardNotif.msg}</div>}
          </div>
        </div>
      </div>

      <div className={styles.notificationOuterContainer}>
        <div id="reward-anim" className={`${styles.notificationInnerContainer} ${styles.rewardNotification}`}>
          <div className={`${styles.rewardTextBox} supportsRtl`}>
            {rewardNotification && <div className={styles.rewardText}>🎉 {rewardNotification?.msg}</div>}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
